import { productClient } from "Clients";
import { SPThunkAction } from "common/ReduxUtils";
import { addLoader, clearLoader } from "common/components/WithLoader/LoadingActions";
import { ProductCollection } from "common/models";
import { chunk, filter, isEmpty } from "lodash";
import { transferCreateGetUnifiedProduct } from "transfers/create/actions";
import pLimit from "p-limit";

export const UnifiedProductsLoaderId = "getUnifiedProductsLoader";
const BATCH_SIZE = 200;
const PARALLEL_BATCHES = 5;

export const getUnifiedProducts =
  (dskus: string[]): SPThunkAction<Promise<ProductCollection>> =>
  async (dispatch, getState) => {
    dispatch(addLoader(UnifiedProductsLoaderId));
    const cachedProductDetails = getState().transferCreate.unifiedProductResponseCache ?? {};

    try {
      const remainingDsku = filter(dskus, (dsku) => !cachedProductDetails[dsku]);

      if (!isEmpty(remainingDsku)) {
        const batches = chunk(remainingDsku, BATCH_SIZE);
        const limit = pLimit(PARALLEL_BATCHES);

        const results = await Promise.all(
          batches.map((batch) =>
            // eslint-disable-next-line @typescript-eslint/promise-function-async
            limit(() => productClient.getUnifiedProducts(batch, { includeProductCasePacks: true }))
          )
        );

        const updatedProductDetails = { ...cachedProductDetails, ...Object.assign({}, ...results) };

        dispatch(transferCreateGetUnifiedProduct(updatedProductDetails));

        return updatedProductDetails;
      }

      return cachedProductDetails;
    } finally {
      dispatch(clearLoader(UnifiedProductsLoaderId));
    }
  };
